<script lang="ts" setup>
import dayjs from 'dayjs';
import type { TimelinePreferenceOption } from '~/types/Job';

const model = defineModel<string | null>();
const timlineDate = defineModel<string | null>('timelineDate');

const deadlineOptions = ref<TimelinePreferenceOption[]>([
  { label: 'ASAP', value: 'asap' },
  { label: 'Flexible', value: 'flexible' },
  { label: 'Choose Date', value: 'choose_date' },
]);

const showDatePicker = ref(false);

const today = computed(() => dayjs().format());

const dateFormatter = computed(() => {
  const date = dayjs().format();

  return $dateFormatter(timlineDate.value || date, 'MM/DD/YY');
});

watch(model, function (newVal) {
  if (newVal !== 'choose_date') {
    timlineDate.value = null;
  }
});
</script>

<template>
  <div v-for="option in deadlineOptions">
    <v-btn
      v-if="option.value !== 'choose_date'"
      class="timeline-preference-btn"
      type="button"
      variant="outlined"
      rounded="pill"
      height="48px"
      @click="model = option.value"
      :class="{ selected: model === option.value }"
    >
      {{ option.label }}
    </v-btn>

    <v-menu
      v-else
      v-model="showDatePicker"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      :offset="10"
    >
      <template v-slot:activator="{ props }">
        <v-btn
          class="timeline-preference-btn"
          :class="{ selected: model === option.value }"
          type="button"
          variant="outlined"
          rounded="pill"
          height="48px"
          v-bind="props"
          @click="model = option.value"
          style="padding-right: 16px"
        >
          <span v-if="timlineDate">
            {{ dateFormatter }}
          </span>
          <span v-else>{{ option.label }}</span>
          <icon size="24" name="ewc:dropdown" class="ml-1"/>
        </v-btn>
      </template>

      <v-date-picker
        v-model="timlineDate"
        color="primary"
        :min="today"
        hide-header
        elevation="8"
        class="timeline-preference-date-picker"
        @update:model-value="showDatePicker = false"
      />
    </v-menu>
  </div>
</template>

<style scoped lang="scss">
.timeline-preference-btn {
  text-transform: none;
  font-weight: 500;
  letter-spacing: normal;
  flex-shrink: 0;
  padding: 0 24px;
  border-color: #e6e6e8;
  background-color: #ffffff;
  color: #01011d;

  &.selected {
    border-color: #01011d !important;
  }
}

:deep(.timeline-preference-date-picker) {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 16px !important;
  overflow: hidden;
}
</style>
